export const PENDING = 'pending';
export const EMITTING = 'emitting';
export const ISSUED = 'issued';
export const REJECTED = 'rejected';
export const FAILED = 'failed';
export const CANCELLING = 'cancelling';
export const CANCELLED = 'cancelled';
export const CANCELLATION_REJECTED = 'cancellation_rejected';
export const CANCELLATION_FAILED = 'cancellation_failed';

export const statuses = Object.freeze({
  [PENDING]: 'Pendente',
  [EMITTING]: 'Processando emissão',
  [ISSUED]: 'Emitida',
  [REJECTED]: 'Rejeitada',
  [FAILED]: 'Falha na emissão',
  [CANCELLING]: 'Cancelando',
  [CANCELLED]: 'Cancelada',
  [CANCELLATION_REJECTED]: 'Cancelamento rejeitado',
  [CANCELLATION_FAILED]: 'Falha no cancelamento',
});

export function getName(value) {
  return statuses[value] || value;
}

export function getLabelClass(status) {
  switch (status) {
    case PENDING: return 'label-info';
    case ISSUED: return 'label-success';
    case REJECTED: return 'label-error';
    case FAILED: return 'label-error';
    case CANCELLING: return 'label-warning';
    case CANCELLED: return 'label-warning';
    default: return '';
  }
}

export function getTextClass(status) {
  switch (status) {
    case PENDING: return 'text-info';
    case ISSUED: return 'text-success';
    case REJECTED: return 'text-error';
    case FAILED: return 'text-error';
    case CANCELLING: return 'text-warning';
    case CANCELLED: return 'text-warning';
    default: return '';
  }
}

export default statuses;
